import { Component, Inject, Vue } from 'vue-property-decorator';
import { Store } from '@/primary/store/Store';

@Component
export default class DepartmentFilterComponent extends Vue {
  @Inject()
  private store!: () => Store;

  @Inject()
  private globalWindow!: () => Window;

  departmentOptions = [
    { value: 'ALL', text: 'Tous' },
    { value: 'HOMME_ET_ENVIRONNEMENT', text: 'Homme et environnement' },
    { value: 'ADAPTATIONS_DU_VIVANT', text: 'Adaptations du vivant' },
    { value: 'ORIGINES_ET_EVOLUTION', text: 'Origines et évolution' },
  ];
  selectedDepartment = 'ALL';

  onChangeDepartment(department: string) {
    this.selectedDepartment = department;
    this.store().saveResearchUnitFilter(undefined);
    this.store().saveDepartmentFilter(department);
  }
}
